import { render, staticRenderFns } from "./gradeOptions.vue?vue&type=template&id=2be66313&scoped=true&"
import script from "./gradeOptions.vue?vue&type=script&lang=js&"
export * from "./gradeOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be66313",
  null
  
)

export default component.exports